export const environment = {
  production: false,
  apiBaseUrl: 'https://api.ploon.pixacare.com',
  appInsights: {
    // TODO : Ask VMA about app insights key for teledeposit
    instrumentationKey: '48616bc2-1351-4811-b737-4ff5288f37db',
  },
};
